import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import swal from "sweetalert";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import Loader from "../Loader";
import { login, clearErrors, loadUser, loginWithSchoolStudent } from "./../../actions/authActions";
import { logoutUser } from "./../../actions/authActions";
import AuthCommonBanner from "./AuthCommonBanner";

// form validation rules
const validationSchema = yup.object().shape({
  email: yup.string().required("Email is required").email("Email is invalid"),
  password: yup.string().required("Password is required"),
});

const schoolStudentSchema = yup.object().shape({
  schoolCode: yup.string().required("School ID is required").trim(),
  studentId: yup.string().required("Student ID is required").trim(),
});

const Login = ({ history, location }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const [errorData, setErrorData] = useState({});
  const [loginMode, setLoginMode] = useState("email");

  const { user, loading, isAuthenticated, error, loginErrors } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (loginErrors) {
      setErrorData(loginErrors);
      // console.log("loginErrors ", loginErrors); return;
    }

    if (isAuthenticated === true && isAuthenticated !== undefined) {
      if (user.role === "admin") {
        history.push("/admin");
        return;
      }
      if (user.accountStatus === "InActive") {
        swal(
          "Login Error",
          "Your account is not yet activated, please activate it from your email account or contact adminstrator.",
          "error"
        );
        logoutHandler();
        return;
      }
      if (user.accountStatus === "Blocked") {
        swal("Login Error", "Your account is blocked.", "error");
        logoutHandler();
        return;
      }
      if (user.accountStatus === "Suspended") {
        swal("Login Error", "Your account is suspended.", "error");
        logoutHandler();
        return;
      }
      // Check if user must change password
      if (user.mustChangePassword) {
        history.push("/force-change-password");
        return;
      }
      const params = new URLSearchParams(location?.search || "");
      const returnTo = params.get("returnTo");
      if (returnTo && /^https?:\/\//i.test(returnTo)) {
        window.location.href = returnTo;
        return;
      }
      const redirectTo = location?.state?.from || "/dashboard";
      history.push(redirectTo);
    } else {
      if (
        error &&
        isAuthenticated === false &&
        error !== "Unauthorised access"
      ) {
        clearErrors();
        return swal("Login Error", error, "error");
      }
    }
    // rns@gmail.com
  }, [dispatch, user, isAuthenticated, alert, error, history, loginErrors, location]);

  const logoutHandler = () => {
    dispatch(logoutUser());
  };

  // functions to build form returned by useForm() hook
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const {
    register: registerSchoolForm,
    handleSubmit: handleSchoolSubmit,
    errors: schoolFormErrors,
    reset: resetSchoolForm,
  } = useForm({
    resolver: yupResolver(schoolStudentSchema),
  });

  const submitForm = (data, e) => {
    e.preventDefault();
    dispatch(login(data.email, data.password));
  };

  const submitSchoolStudentForm = (data, e) => {
    e.preventDefault();
    dispatch(
      loginWithSchoolStudent(data.schoolCode.trim(), data.studentId.trim())
    );
  };

  const switchLoginMode = (mode) => {
    setLoginMode(mode);
    setErrorData({});
    dispatch(clearErrors());
    resetSchoolForm();
  };

  useEffect(() => {
    // After Google OAuth redirect, the token is already in an HttpOnly cookie.
    // Just detect the google=1 param and redirect to dashboard; loadUser will pick up the cookie.
    const params = new URLSearchParams(window.location.search);
    if (params.get("google") === "1") {
      dispatch(loadUser());
      history.push("/dashboard");
    }
  }, [history, dispatch]);

  const handleGoogleLogin = () => {
    // Redirect to backend Google OAuth start
    const apiBase =
      (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_ENDPOINT || "").replace(/\/$/, "");

    if (!apiBase) {
      swal("Login Error", "API base URL is not configured", "error");
      return;
    }

    window.location.href = `${apiBase}/auth/google`;
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <section className="registration-page clearfix fullHt">
            <div className="right-regi-step login-page">
              <div className="vh-center">
                <div className="log-logo">
                    <Link to="/">
                        <img src="/assets/img/logo.png" alt="SITE-LOGO" />
                    </Link>
                </div>
                <h1>
                  User <span>Login</span>
                </h1>
                <div style={{ marginBottom: "18px" }}>
                  <div
                    style={{
                      display: "inline-flex",
                      border: "1px solid #e5e5e5",
                      borderRadius: "999px",
                      overflow: "hidden",
                      background: "#fafafa",
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => switchLoginMode("email")}
                      style={{
                        border: "none",
                        padding: "8px 16px",
                        fontWeight: 600,
                        cursor: "pointer",
                        background: loginMode === "email" ? "#1f9d55" : "transparent",
                        color: loginMode === "email" ? "#fff" : "#555",
                      }}
                    >
                      Email
                    </button>
                    <button
                      type="button"
                      onClick={() => switchLoginMode("school")}
                      style={{
                        border: "none",
                        padding: "8px 16px",
                        fontWeight: 600,
                        cursor: "pointer",
                        background: loginMode === "school" ? "#1f9d55" : "transparent",
                        color: loginMode === "school" ? "#fff" : "#555",
                      }}
                    >
                      School Student
                    </button>
                  </div>
                </div>
                <p className="pull-right">
                  <span className="sub">*</span> is mandatory fields
                </p>
                <div className="inner-que">
                  {loginMode === "email" ? (
                  <form onSubmit={handleSubmit(submitForm)}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="email">
                            Email<span className="sub">*</span>
                          </label>
                          <input
                            ref={register}
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            id="email"
                            name="email"
                            tabIndex="1"
                          />
                          <div className="invalid-feedback">
                            {errors.email?.message}
                          </div>
                          {errorData.email ? (
                            <span className="text-danger">
                              {errorData.email}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="password">
                            Password<span className="sub">*</span>
                          </label>
                          <label className="pull-right dont-have-ac">
                            <Link to="/forgot-password">Forgot?</Link>
                          </label>
                          <input
                            ref={register}
                            type="password"
                            className="form-control"
                            id="password"
                            name="password"
                            tabIndex="2"
                          />
                          <div className="invalid-feedback">
                            {errors.password?.message}
                          </div>
                          {errorData.password ? (
                            <span className="text-danger">
                              {errorData.password}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    <ul className="log-btn-main clearfix">
                      <li className="pull-left">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          tabIndex="3"
                        >
                          Login
                        </button>
                      </li>
                      <li className="pull-right dont-have-ac">
                        Don't have an account?{" "}
                        <Link to="/register">Sign Up</Link>
                      </li>
                    </ul>

                    <div className="text-center" style={{ marginTop: "20px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                        <div style={{ flex: 1, height: 1, background: "#e5e5e5" }} />
                        <span style={{ color: "#777", fontSize: "13px" }}>or</span>
                        <div style={{ flex: 1, height: 1, background: "#e5e5e5" }} />
                      </div>
                      <button
                        type="button"
                        onClick={handleGoogleLogin}
                        className="btn btn-default"
                        style={{
                          width: "100%",
                          border: "1px solid #e5e5e5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          padding: "10px 12px",
                          fontWeight: 600,
                        }}
                      >
                        <span aria-hidden="true" style={{ display: "inline-flex" }}>
                          <svg width="18" height="18" viewBox="0 0 533.5 544.3" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#4285f4" d="M533.5 278.4c0-18.5-1.5-37-4.7-54.9H272.1v103.9h147c-6.3 34.5-25 63.7-53.3 83.1v68.9h86.1c50.5-46.5 81.6-115.1 81.6-201z"/>
                            <path fill="#34a853" d="M272.1 544.3c71.9 0 132.3-23.7 176.4-64.8l-86.1-68.9c-23.9 16-54.4 25.5-90.3 25.5-69.4 0-128.3-46.8-149.3-109.7H35.4v68.9c43.8 87.3 134 148.9 236.7 148.9z"/>
                            <path fill="#fbbc04" d="M122.8 326.4c-10.9-32.7-10.9-68 0-100.7v-68.9H35.4c-46.6 92.3-46.6 200.1 0 292.3z"/>
                            <path fill="#ea4335" d="M272.1 107.7c37.9-.6 74.3 13.6 102.1 39.5l76.1-76.1C404 24.5 343.7.1 272.1 0 169.4 0 79.2 61.6 35.4 148.9l87.4 68.9c20.9-62.9 79.8-109.7 149.3-109.7z"/>
                          </svg>
                        </span>
                        <span>Continue with Google</span>
                      </button>
                    </div>
                  </form>
                  ) : (
                  <form onSubmit={handleSchoolSubmit(submitSchoolStudentForm)}>
                    <div
                      style={{
                        background: "#f8fbf9",
                        border: "1px solid #e3efe8",
                        borderRadius: 12,
                        padding: "20px 18px 8px",
                        marginBottom: 8,
                      }}
                    >
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="schoolCode">
                              School ID<span className="sub">*</span>
                            </label>
                            <input
                              ref={registerSchoolForm}
                              type="text"
                              className="form-control"
                              autoComplete="off"
                              id="schoolCode"
                              name="schoolCode"
                              placeholder="e.g. OTS-AB12CD"
                              style={{
                                minHeight: 48,
                                borderRadius: 8,
                                borderColor:
                                  schoolFormErrors.schoolCode || errorData.schoolCode
                                    ? "#dc3545"
                                    : "#d9dce3",
                                boxShadow: "none",
                                textTransform: "uppercase",
                              }}
                            />
                            <div className="invalid-feedback">
                              {schoolFormErrors.schoolCode?.message}
                            </div>
                            {errorData.schoolCode ? (
                              <span className="text-danger">{errorData.schoolCode}</span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="studentId">
                              Student ID<span className="sub">*</span>
                            </label>
                            <input
                              ref={registerSchoolForm}
                              type="text"
                              className="form-control"
                              autoComplete="off"
                              id="studentId"
                              name="studentId"
                              placeholder="Enter the ID provided by your school"
                              style={{
                                minHeight: 48,
                                borderRadius: 8,
                                borderColor: schoolFormErrors.studentId || errorData.studentId ? "#dc3545" : "#d9dce3",
                                boxShadow: "none",
                              }}
                            />
                            <div className="invalid-feedback">
                              {schoolFormErrors.studentId?.message}
                            </div>
                            {errorData.studentId ? (
                              <span className="text-danger">{errorData.studentId}</span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <p style={{ fontSize: "13px", color: "#5f6b63", marginBottom: 0, lineHeight: 1.5 }}>
                        Enter the School ID and Student ID from your school enrollment.
                        Paid exam plans are added to your account automatically.
                      </p>
                    </div>
                    <ul className="log-btn-main clearfix">
                      <li className="pull-left">
                        <button type="submit" className="btn btn-primary" style={{ minWidth: 200 }}>
                          Login with Student ID
                        </button>
                      </li>
                      <li className="pull-right dont-have-ac">
                        Don&apos;t have an account?{" "}
                        <Link to="/register">Sign Up</Link>
                      </li>
                    </ul>
                  </form>
                  )}
                </div>
              </div>
            </div>
            <AuthCommonBanner></AuthCommonBanner>
          </section>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Login;
